// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__oH7Mx","search":"Settings_search__24vxs","filter":"Settings_filter__2Ksl1"};